/**
 * SaisieRow — ligne d'une saisie clinique (résumé + horodatage + auteur).
 * Extrait de DpiLivePage (US-VDPI-06) pour réutilisation /vocal (Phase 1 A3, DRY).
 */

import type { SaisieOut } from '@/shared/types/dpi';
import { formatTime, summarizeData } from './summarize';
import './dpi.css';

export function SaisieRow({ saisie, isNew }: { saisie: SaisieOut; isNew: boolean }) {
  return (
    <div
      className={`ms-4 mb-1 px-2 py-1 rounded-2 bg-light border ${isNew ? 'dpi-new-entry' : ''}`}
      data-testid="dpi-saisie-row"
    >
      <div className="d-flex align-items-center justify-content-between">
        <span className="small">{summarizeData(saisie.data)}</span>
        <span className="text-muted" style={{ fontSize: '0.7rem' }}>
          {formatTime(saisie.ts)} · {saisie.auteur}
        </span>
      </div>
    </div>
  );
}
